import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { getParticipantQualificationView } from "../../Utils/adminFunctions";

let AdminParticipantQualificationView = () => {
  const { surveyID } = useParams();
  const [qualificationJson, setQualificationJson] = useState("");
  const [surveyName, setSurveyName] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [deviceImage, setDeviceImage] = useState("");

  useEffect(() => {
    async function fetchAPI1() {
      const response = await getParticipantQualificationView(surveyID);

      if (response.status == "success") {
        let questions = JSON.parse(
          response.getParticipantQualificationJson
        ).map((item, i) => (
          <tr key={i++}>
            <td>{item.question}</td>
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              <input
                className="participant_qualification_questions_1"
                type="radio"
                name="questions_name_36"
                defaultValue="yes"
                disabled
              />
            </td>
            <td className="text-center" style={{ verticalAlign: "middle" }}>
              <input
                className="participant_qualification_questions_1"
                type="radio"
                name="questions_name_36"
                defaultValue="no"
                disabled
              />
            </td>
          </tr>
        ));

        setQualificationJson(questions);
        setSurveyName(response.getSurveyName);
        setCompanyLogo(response.getCompanyLogo);
        setDeviceImage(response.getDeviceImage);
      } else {
        return false;
      }
    }
    fetchAPI1();
  }, []);

  return (
    <div>
      <div className="container-fluid custom-container-fluid-background-survey">
        <div className="survey-header">
          <div className="row">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box rounded-0">
                <center>
                  <img
                    src={companyLogo}
                    alt="image not available"
                    height={35}
                  ></img>
                </center>
              </div>
            </div>
          </div>

          <div className="row form-box-top-margin">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box device-box">
                <center>
                  <img
                    src={deviceImage}
                    alt="image not available"
                    className="form-box-device-image"
                  ></img>
                  <br></br>
                  <h6>
                    <b>{surveyName}</b>
                  </h6>
                </center>
              </div>
            </div>
          </div>

          <div className="row form-box-top-margin">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-view-action">
                <Link
                  className="btn btn-sm custom-btn-primary pull-right"
                  to={"/AdminFormView/" + surveyID}
                >
                  <i className="fa fa-arrow-left"></i> Back
                </Link>
              </div>
            </div>
          </div>
          <div className="row form-box-top-margin">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box">
                <table className="table table-bordered form-box-table">
                  <colgroup>
                    <col span={1} style={{ width: "70%" }} />
                    <col span={1} style={{ width: "15%" }} />
                    <col span={1} style={{ width: "15%" }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th style={{ verticalAlign: "middle !important" }}>
                        Participant Qualification
                      </th>
                      <th
                        className="text-center"
                        style={{ verticalAlign: "middle" }}
                      >
                        Yes
                      </th>
                      <th
                        className="text-center"
                        style={{ verticalAlign: "middle !important" }}
                      >
                        No
                      </th>
                    </tr>
                  </thead>
                  <tbody>{qualificationJson}</tbody>
                </table>
                <p>
                  <b>Confidentiality Disclaimer:</b> This document contains
                  confidential communication/information and is soley intended
                  for the use of recipient. The contents of this document may
                  not be copied without written permission from SARACA.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminParticipantQualificationView;
